import { PropsWithChildren } from "react";

export const WarningBanner = ({ children }: PropsWithChildren) => {
  return (
    <div className="bg-lightYellow text-midnight-indigo rounded-md px-3 py-1.5 text-sm">
      {children}
    </div>
  );
};
